export const GrundfosProperties = {
  subcategory_card: true, // Setting this to true causes the sub-categories to be more indented on the left as compared to their parent
  Grundfos_Peerless: {
    skinnySubcat: true
  }
  // accordionMode: true. // FHS-1704: Disable accordionMode, where only one section could be expanded at a time.
};
